module.exports = __webpack_public_path__ + "media/gundula1.5c266dc5.mp3";